import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-center text-xl font-bold" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Antrian Rawat Jalan")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "text-center font-italic text-base"
}
const _hoisted_4 = { class: "text-center font-bold text-7xl" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-bold text-2xl" }, "DIBATALKAN", -1)
const _hoisted_7 = { class: "text-center font-bold font-italic text-sm mt-2" }
const _hoisted_8 = { class: "text-center font-bold font-italic text-sm mt-2" }
const _hoisted_9 = { class: "text-center font-bold font-italic text-sm mt-2" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center font-bold text-base" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "text-center text-base font-italic"
}
const _hoisted_15 = { class: "text-center font-bold font-italic text-sm mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = {
  key: 1,
  class: "text-center font-italic text-base"
}
const _hoisted_21 = {
  key: 2,
  class: "text-center font-italic text-base"
}
const _hoisted_22 = {
  key: 3,
  class: "text-center font-italic text-sx"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'bg-red-100' : _ctx.data.dibatalkan}, "p-2"])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.app_base_data.company_name), 1),
    _hoisted_2,
    (_ctx.data.jam && !_ctx.data.dibatalkan)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Silahkan Datang Jam " + _toDisplayString(_ctx.data.jam), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.data.antrian_poli), 1),
    (_ctx.data.dibatalkan)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, " Dibatalkan Oleh : " + _toDisplayString(_ctx.data.dibatalkan.cancel_by), 1),
          _createElementVNode("div", _hoisted_8, " Dibatalkan Pada : " + _toDisplayString(_ctx.data.dibatalkan.cancel_at), 1),
          _createElementVNode("div", _hoisted_9, " keterangan : " + _toDisplayString(_ctx.data.dibatalkan.keterangan), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, "--( " + _toDisplayString(_ctx.data.antrian_admin) + " )--", 1),
          _createElementVNode("div", _hoisted_12, [
            _createTextVNode(_toDisplayString(_ctx.data.tgl_pemeriksaan) + " - (" + _toDisplayString(_ctx.data.penjamin) + ") ", 1),
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.data.nama_poli), 1)
          ]),
          (_ctx.data.dokter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.data.dokter), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createTextVNode(" RM : " + _toDisplayString(_ctx.data.nomor_rm) + " ", 1),
            _hoisted_16,
            (_ctx.data.kode_bpjs && _ctx.data.penjamin == 'BPJS')
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                  _createTextVNode("BPJS : " + _toDisplayString(_ctx.data.kode_bpjs) + " ", 1),
                  _hoisted_18
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.data.nama) + " ", 1),
            _hoisted_19
          ]),
          (_ctx.data.finger.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.data.finger.msg), 1))
            : _createCommentVNode("", true),
          (_ctx.data.jam && !_ctx.data.dibatalkan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " dimohon datang tepat waktu!! "))
            : _createCommentVNode("", true),
          (_ctx.data.sumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, " by " + _toDisplayString(_ctx.data.sumber), 1))
            : _createCommentVNode("", true)
        ]))
  ], 2))
}